export default __webpack_public_path__ + "static/media/img-auth-1.b061a9de.jpg";